import React from 'react';
import './MascotTooltip.css';

export default function MascotTooltip({ show, tip }) {
  return (
    <div className="mascot-tooltip-fixed">
      <img src={process.env.PUBLIC_URL + '/owl.gif'} alt="吉祥物" className="mascot-img" />
      {show && <div className="mascot-tip-box">{tip}</div>}
    </div>
  );
} 